import * as React from "react";

import {
    DEFAULT_CONTENT_LAYOUT,
    DEFAULT_CONTENT_WIDTH_IN_PX,
    UnitContentInner,
    UnitsLayoutItem,
} from "../Navigation/UnitsLayout/UnitsLayout";
import { usePartialRender } from "../Navigation/UnitPartialRendering/PartiallyRenderedUnit";

import { UnitId } from "./UnitId/UnitId";
import { AddSingleUnitContextProvider } from "./AddSingleUnitContext";
import { IsFilledContext } from "./Internals/OptionalPages/IsFilledContext";
import { UnitLoader } from "./Internals/UnitLoader/UnitLoader";
import { useUnitLayoutingContext } from "./Internals/UnitBorderContext/UnitLayoutingContext";

interface MultipleUnitDefaultContentProps {
    unitId: UnitId;
    showBorder: boolean;
    minHeight: number | undefined;
    children: React.ReactNode;
    onHighlightUnit: (unitId: UnitId) => void;
    onAddInstance: () => void;
}

export function MultipleUnitDefaultContent(props: MultipleUnitDefaultContentProps): JSX.Element {
    const [loaded, partialLoadRef] = usePartialRender();
    const { marginTop, unitContextRef } = useUnitLayoutingContext();

    const unitRef = (element: HTMLDivElement | null) => {
        if (unitContextRef != undefined) {
            unitContextRef.current = element;
        }
        partialLoadRef(element);
    };

    return (
        <AddSingleUnitContextProvider value={props.onAddInstance}>
            <IsFilledContext.Provider value={false}>
                <UnitsLayoutItem
                    ref={unitRef}
                    layoutKind={DEFAULT_CONTENT_LAYOUT}
                    maxWidth={DEFAULT_CONTENT_WIDTH_IN_PX}
                    showBorder={props.showBorder}
                    minHeight={props.minHeight}
                    marginTop={marginTop}
                    onMouseEnter={() => props.onHighlightUnit(props.unitId)}>
                    {!loaded ? <UnitLoader /> : <UnitContentInner>{props.children}</UnitContentInner>}
                </UnitsLayoutItem>
            </IsFilledContext.Provider>
        </AddSingleUnitContextProvider>
    );
}
